// extracted by mini-css-extract-plugin
export default {"header":"contact-form_header__kQDKK","input":"contact-form_input__+-0hH","tip":"contact-form_tip__9T-es","btn":"contact-form_btn__HNrGt"};